<template>
  <div>
    <h3 class="mt-8 mb-6 text-3xl md:text-4xl relative  font-medium">Sharing and Reviews</h3>
    <p class="text-lg font-medium">Where would you like customers to share and review?</p>
    <p class="text-lg text-light">Select the platforms where you currently have an online presence.</p>
    <vs-collapse type="margin" :open-hover="true" class="small" >
      <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle">
        <div slot="header">
          Why?
        </div>
        We'll use this information to import reviews from your review platforms, and to know where to send customers to collect more!
      </vs-collapse-item>
    </vs-collapse>
    <div :class="{'opacity-25': needHelpSocialReviews}">
    <div class="my-8">
      <p class="text-xl text-dark mb-1 font-medium">
        <img class="w-5 inline-block pt_logosmallfloat" src="@/assets/images/logo/fb.png"/>
        Facebook Share
        <vs-switch  class="float-right w-16" v-model="chooseFbS"><span slot="off">Off</span><span slot="on">On</span></vs-switch>
      </p>
      <p class="text-sm">Encourage customers to share their experience with friends on Facebook.</p>
      <div class="my-2" v-if="chooseFbS">
        <vs-input
          label="Facebook page address"
          name="'Facebook page address'"
          placeholder="https://www.facebook.com/feedback.link"
          class="w-full"
          v-validate.immediate="chooseFbS ? {required: true, url: {require_protocol: true }} : {url: {require_protocol: true }}"
          v-model="fbAddress"
          icon-pack="feather"
          icon="icon-facebook"
        />
        <p class="text-sm">Paste link to Facebook page (not share address).</p>
        <img class="w-full block mt-4" src="@/assets/images/misc/facebookhow.png"/>
        <p class="text-sm mt-1">Copy and paste the full address (including the "https://") of your business' Facebook page.</p>
        <vs-divider/>
      </div>
    </div>

    <div class="my-8">
      <p class="text-xl text-dark mb-1 font-medium">
        <img class="w-5 inline-block pt_logosmallfloat" src="@/assets/images/logo/fb.png"/>
        Facebook Review
        <vs-switch  class="float-right w-16" v-model="chooseFbR"><span slot="off">Off</span><span slot="on">On</span></vs-switch>
      </p>
      <p class="text-sm">Encourage customers to review on your Facebook reviews section.</p>
      <div class="my-2" v-if="chooseFbR">
        <vs-input
          label="Facebook page address"
          placeholder="https://www.facebook.com/feedback.link"
          class="w-full"
          name="'Facebook page address'"
          v-validate.immediate="chooseFbR ? {required: true, url: {require_protocol: true }} : {url: {require_protocol: true }}"
          v-model="fbAddress"
          icon-pack="feather"
          icon="icon-facebook"
        />
        <p class="text-sm">Paste link to Facebook page (not Facebook reviews page).</p>
        <img class="w-full block mt-4" src="@/assets/images/misc/facebookhow.png"/>
        <p class="text-sm mt-1">Copy and paste the full address (including the "https://") of your business' facebook page address.</p>
        <vs-divider/>
      </div>
    </div>



    <div class="my-8">
      <p class="text-xl text-dark mb-1 font-medium">
        <img class="w-5 inline-block pt_logosmallfloat" src="@/assets/images/logo/gp.png"/>
        Google
        <vs-switch  class="float-right w-16" v-model="chooseGP"><span slot="off">Off</span><span slot="on">On</span></vs-switch>
      </p>
      <p class="text-sm">Encourage customers to review on Google.</p>
      <div class="my-2" v-show="chooseGP">

        <label class="vs-input--label">Provide Google location</label>
        <div id="gmapswrap">
          <div class="inner">
            <div class="vs-con-input px-4">
            <input id="pac-input" ref="gmsearch" type="text" maxlength="50" class="vs-inputx vs-input--input normal" placeholder="Search for your business..." style="border: 1px solid rgba(0, 0, 0, 0.2);">
            </div>
            <div id="map"></div>
          </div>
        </div>
        <p v-if="googleMaps !== ''" class="mt-2"><strong v-if="googleMaps !== ''">Selected location: </strong>{{ googleMaps.name + ', ' + googleMaps.formatted_address }} <a class="purple block" href="" @click.prevent="clearGoogleMaps">X Remove</a></p>
        <p class="mt-2" v-else> Business not listed? Continue with signup, and once in your dasbhoard reach out to support by clicking the (?) button.</p>
        <vs-divider/>
      </div>

    </div>

    <div class="my-8">
      <p class="text-xl text-dark mb-1 font-medium">
        <img class="w-5 inline-block pt_logosmallfloat" src="@/assets/images/logo/tw.png"/>
        Post on X
        <vs-switch  class="float-right w-16" v-model="chooseTw"><span slot="off">Off</span><span slot="on">On</span></vs-switch>
      </p>
      <p class="text-sm">Encourage customers to post about your business on X.</p>
      <div class="my-2" v-if="chooseTw">
        <vs-input
          label="X handle"
          placeholder="getfeedbacklink"
          class="w-full"
          v-model="twAddress"
          icon-pack="feather"
          name="'X handle'"
          v-validate.immediate="chooseTw ? {required: true}: ''"
          icon="icon-at-sign"
        />
        <p class="text-sm mt-1">Type the X handle of your business, or you can simply copy and paste your X profile address.</p>
        <vs-divider/>
      </div>
    </div>

    <div class="my-8">
      <p class="text-xl text-dark mb-1 font-medium">
        <img class="w-5 inline-block pt_logosmallfloat" src="@/assets/images/logo/tp.png"/>
        Trustpilot
        <vs-switch  class="float-right w-16" v-model="chooseTP"><span slot="off">Off</span><span slot="on">On</span></vs-switch>
      </p>
      <p class="text-sm mb-4">Encourage customers to review on Trustpilot.</p>
      <div v-if="chooseTP" class="my-2">
        <vs-input
          v-model="tpAddress"
          v-validate.immediate="chooseTP ? {required: true, url: {require_protocol: true }} : {url: {require_protocol: true }}"
          label="Trustpilot page address"
          name="'Trustpilot page address'"
          placeholder="https://www.trustpilot.com/review/yoursite"
          class="w-full"
        />
        <img class="w-full block mt-4" src="@/assets/images/misc/trustpilothow.png"/>
        <p class="text-sm mt-1">Copy and paste the full address (including the "https://") of your business' Trustpilot page.</p>
        <vs-divider/>
      </div>
    </div>    

    <div class="my-8">
      <p class="text-xl text-dark mb-1 font-medium">
        <img class="w-5 inline-block pt_logosmallfloat" src="@/assets/images/logo/ct.png"/>
        Capterra
        <vs-switch  class="float-right w-16" v-model="chooseCT"><span slot="off">Off</span><span slot="on">On</span></vs-switch>
      </p>
      <p class="text-sm mb-4">Encourage customers to review on Capterra.</p>
      <div v-if="chooseCT" class="my-2">
        <vs-input
          v-model="caAddress"
          name="'Capterra page address'"
          v-validate.immediate="chooseCT ? {required: true, url: {require_protocol: true }} : {url: {require_protocol: true }}"
          label="Capterra page address"
          placeholder="https://www.capterra.com/p/184192/yourbusiness"
          class="w-full"
        />
        <img class="w-full block mt-4" src="@/assets/images/misc/capterrahow.png"/>
        <p class="text-sm mt-1">Copy and paste the full address (including the "https://") of your business' Capterra page.</p>
        <vs-divider/>
      </div>
    </div>

    <div class="my-8">
      <p class="text-xl text-dark mb-1 font-medium">
        <img class="w-5 inline-block pt_logosmallfloat" src="@/assets/images/logo/ta.png"/>
        Tripadvisor
        <vs-switch  class="float-right w-16" v-model="chooseTA"><span slot="off">Off</span><span slot="on">On</span></vs-switch>
      </p>
      <p class="text-sm">Encourage customers to review on Tripadvisor.</p>
      <div v-if="chooseTA" class="my-2">
        <vs-input
          v-model="taAddress"
          v-validate.immediate="chooseTA ? {required: true, url: {require_protocol: true }} : {url: {require_protocol: true }}"
          label="Tripadvisor address"
          name="'Tripadvisor page address'"
          placeholder="www.tripadvisor.com/...g63810-Reviews-YourBusiness.html"
          class="w-full"
        />
        <img class="w-full block mt-4" src="@/assets/images/misc/tripadvisorhow.png"/>
        <p class="text-sm mt-1">Copy and paste the full address (including the "https://") of your business' Tripadvisor page.</p>
        <vs-divider/>
      </div>
    </div>

    <div class="my-8">
      <p class="text-xl text-dark mb-1 font-medium">
        <img class="w-5 inline-block pt_logosmallfloat" src="@/assets/images/logo/ye.png"/>
        Yelp
        <vs-switch  class="float-right w-16" v-model="chooseYE"><span slot="off">Off</span><span slot="on">On</span></vs-switch>
      </p>
      <p class="text-sm">Encourage customers to review on Yelp.</p>
      <div v-if="chooseYE" class="my-2">
        <p class="text-sm">Encouraged to leave a review on your Yelp page.</p>
        <vs-input
          v-model="yeAddress"
          label="Yelp address"
          name="'Yelp page address'"
          v-validate.immediate="chooseYE ? {required: true, url: {require_protocol: true }} : {url: {require_protocol: true }}"
          placeholder="https://www.yelp.com/biz/yourbusiness"
          class="w-full"
        />
        <img class="w-full block mt-4" src="@/assets/images/misc/yelphow.png"/>
        <p class="text-sm mt-1">Copy and paste the full address (including the "https://") of your business' Yelp page.</p>
        <vs-divider/>
      </div>
    </div>

    <div class="my-8">
      <p class="text-xl text-dark mb-1 font-medium">
        <img class="w-5 inline-block pt_logosmallfloat" src="@/assets/images/logo/fs.png"/>
        Foursquare
        <vs-switch  class="float-right w-16" v-model="chooseFS"><span slot="off">Off</span><span slot="on">On</span></vs-switch>
      </p>
      <p class="text-sm">Encourage customers to review on Foursquare.</p>
      <div v-if="chooseFS" class="my-2">
        <vs-input
          v-model="fsAddress"
          v-validate.immediate="chooseFS ? {required: true, url: {require_protocol: true }} : {url: {require_protocol: true }}"
          name="'Foursquare page address'"
          label="Foursquare address"
          placeholder="https://www.foursquare.com/v/yourbusiness/2e5f2a4"
          class="w-full"
        />
          <img class="w-full block mt-4" src="@/assets/images/misc/foursquarehow.png"/>
        <p class="mt-1">Copy and paste the full address (including the "https://") of your business' Foursquare page. Visit <a href="https://foursquare.com/city-guide" target="_blank">The Foursquare City Guide</a> to find your Foursquare link.</p>
      </div>
    </div>
    <vs-divider/>
    <div class="my-2 flex items-center">
      <feather-icon icon="InfoIcon" svgClasses="stroke-current text-light w-6 h-6" class="mx-2" />
      <span class="inline-block max-w-lg text-light">Need help getting set up? <span class="font-medium">Continue with sign up</span> and <span class="font-medium">reach out</span> to support once inside your dashboard.</span>
    </div>
    </div>

    <div class="overflow-visible">
    <p class="text-primary clear-both text-lg my-10 mb-4 font-medium" v-if="message">{{ message }}</p>
    <p class="text-primary clear-both text-lg my-10 mb-4 font-medium" v-if="errors.any()">{{ errors.all()[0] }}. You'll need to correct this if you want to switch on that platform.</p>
    <vs-button size="large" type="flat" @click="$emit('back')" class="my-6 py-6 text-base lg:text-xl">< Back</vs-button>
    <vs-button size="large" :disabled="errors.any()" class="float-right font-semibold my-6 w-48 py-6 text-base lg:text-xl lg:w-64 pmybtnshdw" @click="next"  icon-pack="feather" icon="icon-chevron-right" icon-after >{{ $route.name === 'addnew' ? 'Add Space' : 'Let\'s Go!' }}</vs-button>
    </div>
  </div>
</template>


<script>


/*


  Jan 2023 Removed G2:
  <div class="my-8">
      <p class="text-xl text-dark mb-1 font-medium">
        <img class="w-5 inline-block pt_logosmallfloat" src="@/assets/images/logo/gc.png"/>
        G2
        <vs-switch  class="float-right w-16" v-model="chooseG2"><span slot="off">Off</span><span slot="on">On</span></vs-switch>
      </p>
      <p class="text-sm mb-4">Encourage customers to review on G2.</p>
      <div v-if="chooseG2" class="my-2">
        <vs-input
          v-model="g2Address"
          name="'G2 page address'"
          v-validate.immediate="chooseG2 ? {required: true, url: {require_protocol: true }} : {url: {require_protocol: true }}"
          label="G2 Page Address"
          placeholder="https://www.g2.com/products/yourbusiness/reviews"
          class="w-full"
        />
        <img class="w-full block mt-4" src="@/assets/images/misc/g2how.png"/>
        <p class="text-sm mt-1">Copy and paste the full address (including the "https://") of your business' G2 page.</p>
        <vs-divider/>
      </div>


    </div>



  Map inputs to vmodel
  Validate inputs
  Build register


  LEAVE TUNING FOR LAST!!


*/


import signupComputedVmodel from '../common/setSignupComputedVmodel'
import store from '../../../store/store'

function replaceDomains (a) {
  return a.replace('.co.uk/','.com/').replace('.no/','.com/').replace('.com.au/','.com/').replace('.dk/','.com/').replace('.ca/','.com/').replace('.nl/','.com/').replace('.com.in/','.com/').replace('.com.ie/','.com/').replace('.co.nz/','.com/').replace('.com.au/','.com/').replace('.de/','.com/').replace('.co.za/','.com/')
}

export default {

  data () {
    return {
      fbChoiceError: false,
      gmInfoWindow: false,
      gmMarker: false,
      message: false
      }
    },
    computed: {
      socialMedia () {
        return store.getters['socialMedia']
      },
      googleMaps: {
        get() {
          return store.state.signUpState.recorded.socialMediaReviews.googleMaps
        },
        set(val) {
          this.$store.commit('signUpState/SET_SIGNUP_RECORDED_STATE', {
            target: ['socialMediaReviews', 'googleMaps'],
            value: val
          })
        }
      },
      chooseFbS: signupComputedVmodel(store, ['socialMediaReviews', 'chooseFbS']),
      chooseFbR: signupComputedVmodel(store, ['socialMediaReviews', 'chooseFbR']),
      chooseTw: signupComputedVmodel(store, ['socialMediaReviews', 'chooseTw']),
      chooseGP: signupComputedVmodel(store, ['socialMediaReviews', 'chooseGP']),
      chooseTP: signupComputedVmodel(store, ['socialMediaReviews', 'chooseTP']),
      chooseCT: signupComputedVmodel(store, ['socialMediaReviews', 'chooseCT']),
      chooseTA: signupComputedVmodel(store, ['socialMediaReviews', 'chooseTA']),
      needHelpSocialReviews: signupComputedVmodel(store, ['needHelpSocialReviews']),
      chooseYE: signupComputedVmodel(store, ['socialMediaReviews', 'chooseYE']),
      chooseFS: signupComputedVmodel(store, ['socialMediaReviews', 'chooseFS']),
      fbAddress: signupComputedVmodel(store, ['socialMediaReviews', 'facebook'], true),
      twAddress: signupComputedVmodel(store, ['socialMediaReviews', 'twitter'], true),
      tpAddress: signupComputedVmodel(store, ['socialMediaReviews', 'trustPilot'], true),
      g2Address: signupComputedVmodel(store, ['socialMediaReviews', 'g2'], true),
      caAddress: signupComputedVmodel(store, ['socialMediaReviews', 'capterra'], true),
      taAddress: signupComputedVmodel(store, ['socialMediaReviews', 'tripAdvisor'], true),
      yeAddress: signupComputedVmodel(store, ['socialMediaReviews', 'yelp'], true),
      fsAddress: signupComputedVmodel(store, ['socialMediaReviews', 'fourSquare'], true)
  },
  mounted () {
    this.loadGoogleMaps()
  },
  watch: {
    chooseGP () {
      this.message = false
    },
    needHelpSocialReviews () {
      this.message = false
    },
    socialMedia: {
        handler() {
          this.message = false
        },
        deep: true
    }
  },
  methods: {
    urlWithoutExtras (url) {
      if (url === '') return ''
      let urlO = new URL(url)
      let toReturn = urlO.origin + urlO.pathname
      if(toReturn.substr(-1) === '/') {
        toReturn = toReturn.substr(0, toReturn.length - 1);
      }
      return toReturn
    },
    clearGoogleMaps() {
      this.googleMaps = ''
      this.gmInfoWindow.close()
      this.gmMarker.setVisible(false)
      document.getElementById('pac-input').value = ''
    },
    next () {


      if (!this.needHelpSocialReviews) {

        if (this.chooseFbS) {
          if (this.fbAddress.indexOf('facebook.com/') === -1 && this.fbAddress !== '') {
            this.message = "Please enter a valid Facebook page address to continue."
            return
          }
        }

        if (this.chooseFbR) {
          if (this.fbAddress.indexOf('facebook.com/') === -1 && this.fbAddress !== '') {
            this.message = "Please enter a valid Facebook page address to continue."
            return
          }
        }

        if (this.chooseGP) {
          //BIG RISK IF GOOGLE DOESN'T LOAD CORRECTLY
          if (this.googleMaps === '') {
            this.message = "You've selected 'Google' but didn't locate your business on the map search. You'll need to fix this if you want to switch on Google reviews."
            return
          }
        }

        //Format urls to ensure they're sent to BE without trailing params and #s
        let facebookAddress = this.urlWithoutExtras(this.fbAddress.trim()).replace('/reviews/','').replace('/reviews','')
        this.fbAddress = facebookAddress !== "" ? facebookAddress + '/reviews' : ''
        this.fbAddress = this.fbAddress.replace('web.facebook.com','www.facebook.com')
        this.tpAddress = this.urlWithoutExtras(this.tpAddress.trim())
        this.g2Address = this.urlWithoutExtras(this.g2Address.trim())
        this.caAddress = this.urlWithoutExtras(this.caAddress.trim())
        this.taAddress = replaceDomains(this.urlWithoutExtras(this.taAddress.trim()))
        this.yeAddress = this.urlWithoutExtras(this.yeAddress.trim())
        this.fsAddress = this.urlWithoutExtras(this.fsAddress.trim())


        


        /*
        if (this.chooseTP) {
          if (this.tpAddress === '') {
            this.message = "You've selected 'Trustpilot' but didn't give a Trustpilot page address."
            return
          }
          if (this.tpAddress.indexOf('trustpilot.com/') === -1) {
            this.message = "Please enter a valid Trustpilot page address."
            return
          }
        }

        if (this.chooseG2) {
          if (this.g2Address === '') {
            this.message = "You've selected 'G2' but didn't give your G2 page address."
            return
          }
          if (this.g2Address.indexOf('g2.com/products/') === -1) {
            this.message = "Please enter a valid G2 page address."
            return
          }
        }

        if (this.chooseCT) {
          if (this.caAddress === '') {
            this.message = "You've selected 'Capterra' but didn't give your Capterra page address."
            return
          }
          if (this.caAddress.indexOf('capterra.com/p') === -1) {
            this.message = "Please enter a valid Capterra page address."
            return
          }
        }

        if (this.chooseTA) {
          if (this.taAddress === '') {
            this.message = "You've selected 'Tripadvisor' but didn't give your Tripadvisor page address."
            return
          }
          if (this.taAddress.indexOf('tripadvisor.com/') === -1) {
            this.message = "Please enter a valid Tripadvisor page address."
            return
          }
        }

        if (this.chooseYE) {
          if (this.yeAddress === '') {
            this.message = "You've selected 'Yelp' but didn't give your Yelp page address."
            return
          }
          if (this.yeAddress.indexOf('yelp.com/biz/') === -1) {
            this.message = "Please enter a valid Yelp page address."
            return
          }
        }

        if (this.chooseFS) {
          if (this.fsAddress === '') {
            this.message = "You've selected 'Foursquare' but didn't give your Foursquare page address."
            return
          }
          if (this.fsAddress.indexOf('foursquare.com/') === -1) {
            this.message = "Please enter a valid Foursquare page address."
            return
          }
        }
        */

      }

      this.$emit('next')


    },
    loadGoogleMaps() {

          //commented out old functionality

          /*if (this.$route.name === 'setup'){
            this.websiteAddress = store.state.signUpState.recorded.businessInfo.webAddress
          }*/

          //let isSetup = (this.$route.name === 'setup')


          //GoogleMapsApi.LIBRARIES = ['places']
          //GoogleMapsApi.KEY = 'AIzaSyA-kZ2LRZSIW-8iYAdYnbQkQr9B5uh2ISQ'
          //GoogleMapsApi.load((google) => {

            //this.googleMapsReady = true

            let googleMaps = google.maps
            let map = new googleMaps.Map(document.getElementById('map'), {
              center: {
                lat: 41.9030632,
                lng: 12.466275999999993
              },
              zoom: 2,
              clickableIcons: false,
              mapTypeControl: false,
              streetViewControl: false,
              fullscreenControl: false
            });

            let input = document.getElementById('pac-input');

            let autocomplete = new googleMaps.places.Autocomplete(input, {
              types: ['establishment']
            });

            autocomplete.bindTo('bounds', map);

            map.controls[googleMaps.ControlPosition.TOP_LEFT].push(input);

            let infowindow = new googleMaps.InfoWindow();

            this.gmInfoWindow = infowindow

            let marker = new googleMaps.Marker({
              map: map
            });

            this.gmMarker = marker

            marker.addListener('click', function() {
              infowindow.open(map, marker);
            });

            autocomplete.addListener('place_changed', () => {


              this.message = false

              infowindow.close();
              let place = autocomplete.getPlace();

              if (!place.geometry) {
                this.googleMaps = place
                return;
              }

              if (place.geometry.viewport) {
                map.fitBounds(place.geometry.viewport);
              } else {
                map.setCenter(place.geometry.location);
                map.setZoom(17);
              }

              // Set the position of the marker using the place ID and location.
              marker.setPlace({
                placeId: place.place_id,
                location: place.geometry.location
              });

              marker.setVisible(true);

              //noconsoleconsole.log(this)

              infowindow.setContent('<div><h2 class="purpleh2">' + place.name + '</h2><p>' + place.formatted_address + '</p>');
              infowindow.open(map, marker);

              let oldGeomLocation = { ...place.geometry.location }

              delete place.geometry
              place.geometry = {}
              place.geometry.location = {}
              place.geometry.location.lat = oldGeomLocation.lat()
              place.geometry.location.lng = oldGeomLocation.lng()
              delete place['opening_hours']
              delete place['photos']
              delete place.reviews
              delete place.adr_address

              this.googleMaps = place

              /*
              HOW TO GET DETAILS OF MAPS PLACE BY PLACE ID:
              let service = new googleMaps.places.PlacesService(map);
              service.getDetails({
                placeId: place.place_id
              }, function(place, status) {
                details_container.innerHTML = '<p><strong>Status:</strong> <code>' + status + '</code></p>' +
                  '<p><strong>Place ID:</strong> <code>' + place.place_id + '</code></p>' +
                  '<p><strong>Location:</strong> <code>' + place.geometry.location.lat() + ', ' + place.geometry.location.lng() + '</code></p>' +

                  '<p><strong>Formatted address:</strong> <code>' + place.formatted_address + '</code></p>' +
                  '<p><strong>GMap Url:</strong> <code>' + place.url + '</code></p>' +
                  '<p><strong>Place details:</strong></p>' +
                  '<pre>' + JSON.stringify(place, null, " ") + '</pre>';

              });*/
            });

    }
  }

}


</script>
